import React from 'react';
import Modal from '../../Components/Modal';
import Form, { TextArea, Actions, ULID, Services, RequiredValidator, Switch } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';

const AddQuote = ({isOpen, customer, setIsOpen, then}) => {
    return <Modal title="Add Quote" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {(customer && isOpen) && <Inner {...{customer, then}} />}
    </Modal>
}

const Inner = ({customer, then}) => {
    const {addQuote} = useCustomer(customer.id);

    return <Form onSubmit={(data) => addQuote(data)} afterSubmit={then} closeModalOnSubmit>
        <Services name="services" label="Service" validators={[RequiredValidator]} showAddService />
        <TextArea label="Notes" name="note" />
        <Switch label="Add job for quote"
            name="addJob"
            help="Add a job for this quote so you can schedule it in"
        />
        <ULID name="quoteId" />
        <Actions submit cancel />
    </Form>;
}

export default AddQuote;
